import React, { Component } from 'react';
import { Autoplay, Navigation, Pagination, Virtual } from 'swiper/modules';
// Import Swiper styles
import 'swiper/css';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
import '../Controls/inventory-selector.css';
import '../../Controls/ticker.css';

export default class MessageTicker extends Component {
    constructor(props) {
        super(props);
        this.state = {
            messages: ['init'],
        };

        this.swiper = null;
        this.timeout = null;

        this.update = false;
    }

    componentDidMount() {
        window.addEventListener('message-event',
            this.receiveMessageEvent);
    }

    componentWillUnmount() {
        window.removeEventListener('message-event',
            this.receiveMessageEvent);
    }

    receiveMessageEvent = (e) => {
        const message = e.detail;
        if (this.swiper && !this.swiper.autoplay.running) {
            this.swiper.autoplay.start()
        }

        if (this.swiper && this.swiper.slides.length - this.swiper.activeIndex > 10) {
            // delay = 0;
            this.swiper.slideTo(this.swiper.slides.length - 10);
            this.swiper.autoplay.start()
        }

        this.setState({messages: [...this.state.messages, message].slice(-4)})
    };

    render() {
        let delay = 200;

        return (
            <div className={'ticker-container'}>
                <div className={'ticker-selector-anchor'}>
                    <div>
                        <Swiper
                            slidesPerView={5}
                            spaceBetween={30}
                            centeredSlides={true}
                            navigation={true}
                            // modules={[Navigation]}

                            // slidesPerView={6}
                            // watchSlidesProgress={true}
                            // spaceBetween={30}
                            grabCursor={true}
                            onSwiper={(swiper) => {
                                this.swiper = swiper;
                            }}
                            // onClick={this.onClick}
                            // className="swiper-min-height"
                            autoplay={{
                                delay: delay,
                                disableOnInteraction: true,
                                stopOnLastSlide: true,
                                pauseOnMouseEnter: false,
                            }}
                            loop={false}
                            // pagination={{
                            //     clickable: true,
                            // }}
                            modules={[Autoplay, Pagination, Navigation, Virtual]}
                            // modules={[Autoplay, Navigation, Virtual]}
                            // modules={[Virtual]}
                            // virtual
                            // freeMode={true}

                            pagination={{
                                type: 'progressbar'
                            }}

                        >
                            {this.state.messages.map((message, index) => {
                                return <SwiperSlide key={`gi-${index}`}
                                                    virtualIndex={index}
                                        // className={'swiper-slide-width'}
                                >
                                    <div className={'ticker-text'}>{message}</div>
                                    <img
                                        src={'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs='}
                                        alt="message"
                                        className={'ticker-image'}
                                    />
                                </SwiperSlide>
                            })}

                        </Swiper>
                    </div>
                </div>

            </div>
        )
    }
}
